<script lang="ts">
  import ChipInput from "../input/ChipInput.svelte";
  import type { FacetValue, FacetValueOptions } from "./type.ts";
  import { MultiSelect } from "../facet-value-input";
  import { Text } from "../facet-value-label";

  interface Props extends FacetValue, FacetValueOptions {}

  let {
    input = checkbox,
    children = text,
    saved = false,
    variantGray = false,
    additionalClasses = "",
    ...rest
  }: Props = $props();
</script>

{#snippet checkbox()}
  <MultiSelect {...rest} />
{/snippet}

{#snippet text()}
  <Text size="125" {...{ ...rest, showCount: false }} />
{/snippet}

<ChipInput {input} {variantGray} {additionalClasses}>
  {#if saved}
    <oc-icon-v1 class="hc_icon--margin-right" type="wishlist-active" size="50"></oc-icon-v1>
  {/if}
  {@render children?.()}
</ChipInput>

<style lang="scss">
  .hc_icon--margin-right {
    margin-right: var(--oc-semantic-spacing-25);
  }
</style>
